export default __webpack_public_path__ + "static/media/chilltechLight.43cfb817.png";